<template>
  <!-- 对话框 -->
  <el-dialog :visible.sync="show" width="500px" :before-close="closeDialog" center>

    <el-form>

      <el-form-item label="收回原因:" label-width='120px'>
        <el-input v-model="submit_data.remarks" style="width: 80%;">
        </el-input>
      </el-form-item>

    </el-form>

    <!-- 对话框底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="orderBack" type="primary" v-if="load">确认</el-button>
      <el-button @click="orderBack" type="primary" disabled v-else><i class="el-icon-loading"></i></el-button>
      <el-button @click="closeDialog">返回</el-button>
    </span>

  </el-dialog>
</template>

<script>
  var _this, district, map, msgDig;
  import axios from 'axios'; // AJAX封装类
  import bus from '../../../common/bus.js'; // AJAX封装类
  export default {
    components: {

    },
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;



        _this.submit_data.order_code = _this.data;


        _this.onSocket();


      },
    },
    data() {
      return {


        show: false,

        load: true,

        // 表单数据
        submit_data: {
          order_code: '',
          remarks: ''
        },
        submit_rules: {
          order_code: {
            placeholder: '订单编码',
            rules: {
              required: true,
              message: '订单编码',
              regulation: 'egt_str',
              rulesData: 0
            }
          },
          remarks: {
            placeholder: '收回原因',
            rules: {
              required: false,
              message: '收回原因',
              regulation: 'egt_str',
              rulesData: 0
            }
          }
        },



      };
    },
    created() {

      _this = this;
      // 接收连接Socket的通知
      bus.$on('Socket', msg => {

        _this.onSocket();

      });

    },
    methods: {
      onSocket() {
        // 长连接接收内容
        _this.global.ws.onmessage = function (res) {


          var resData = JSON.parse(res.data);

          _this.$driverState(resData);



          if (resData.identification == "adminTakeBack" && resData.header == "error") {
            console.log(resData);

            // 后台收回错误信息
            if (msgDig) {
              msgDig.close();
            }
            msgDig = _this.$message.error({
              message: resData.msg,
              duration: 0,
              showClose: true
            });
            _this.load = true;
          }  else if (resData.header == "error") {
            // 接收到弹窗信息

            _this.$message.error(resData.msg)



          }else if (resData.identification == "adminTakeBack" && resData.header == "success") {
            console.log(resData);

            // 后台收回成功信息

            _this.$message.success(resData.msg);
            _this.closeDialog();


            _this.$emit('onSubmit');

            _this.load = true;
          } else if (resData.identification == "link" && resData.header == "logout") {
            // 接收token失效

            // 关闭socket
            bus.$emit('firstlog', false);


          }

        };


      },
      orderBack() {

        _this.load = false;

        var sendData = {
          "ws_mode": 'adminTakeBack',
          'order_code': _this.submit_data.order_code,
          'remarks': _this.submit_data.remarks
        }


        // 发送数据
        _this.global.ws.send(JSON.stringify(sendData));

        // _this.closeDialog();
        // _this.$emit('onSubmit');
      },




      closeDialog() {

        _this.submit_data = {
          order_code: '',
          consumer_duty_cancel_point: '0',
          driver_duty_cancel_point: '0',
          consumer_duty_cancel_amount: '0',
          remarks: ''
        }
        _this.show = false;

        // 关闭时通知App.vue链接Socket
        bus.$emit('appToSocket');
      },



    }
  };
</script>

<style scoped>
  #container_add {
    height: 90%;
    width: 65%;
    float: left;
  }

  .order-model {
    margin: 20px 0;
  }


  .mode-data {

    margin: 20px 0;
  }

  iframe {
    width: 100%;
    border: medium none;
    height: 100%;
  }

  h4 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
  }

  h5 {
    font-size: 20px;
    font-weight: normal;
  }

  .text-btn {
    font-size: 18px;
    margin-left: 20px;
    padding: 5px;
    display: block;
  }

  .box>div {
    margin: 20px 0;
  }
</style>